import { isDefined } from '@sgme/fp';

export interface PriceTable {
  columns: string[];
  rows: number[][];
}

export function interpolateCorrelationFromPrice(prices: PriceTable, price: number | undefined) {
  return interpolate(prices, price, 'price', 'correlation', true);
}

export function interpolatePriceFromCorrelation(prices: PriceTable, correlation: number | undefined) {
  return interpolate(prices, correlation, 'correlation', 'price', false);
}

function interpolate(
  table: PriceTable,
  value: number | undefined,
  searchedKey: string,
  toInterpolateKey: string,
  isOrderedAscending: boolean,
) {
  const lastIndex = table.rows.length - 1;
  if (isDefined(value)) {
    const searchedKeyIndex = table.columns.findIndex(s => s.toLowerCase() === searchedKey);
    const toInterpolateKeyIndex = table.columns.findIndex(s => s.toLowerCase() === toInterpolateKey);
    let minIndex = isOrderedAscending
      ? table.rows.findIndex(p => p[searchedKeyIndex] >= value)
      : table.rows.findIndex(p => p[searchedKeyIndex] <= value);
    const aboveLastElement = minIndex === -1;
    const belowFirstElement = minIndex === 0;
    if (aboveLastElement) {
      minIndex = lastIndex;
    }

    const previousElement = belowFirstElement ? table.rows[minIndex] : table.rows[minIndex - 1];
    const nextElement = belowFirstElement ? table.rows[minIndex + 1] : table.rows[minIndex];
    const baseInterpolated = aboveLastElement
      ? nextElement[toInterpolateKeyIndex]
      : previousElement[toInterpolateKeyIndex];
    const baseSearchedDiff =
      value - (aboveLastElement ? nextElement[searchedKeyIndex] : previousElement[searchedKeyIndex]);

    return (
      baseInterpolated +
      (baseSearchedDiff * (nextElement[toInterpolateKeyIndex] - previousElement[toInterpolateKeyIndex])) /
        (nextElement[searchedKeyIndex] - previousElement[searchedKeyIndex])
    );
  }
}
